import React, { useState, useEffect } from "react";
import { useTabContext } from "../context/context";
import { usePermissions } from "../data/Permissions";
import { useFormContext } from "react-hook-form";
import { GoogleMap, Marker } from "@react-google-maps/api";
import ServiceCheckbox from "../components/ServiceCheckbox";

const ListingDetails = () => {
  const { provID, providerInfo, premiumInfo, inquiryEmail, setInquiryEmail, allowedServices, googleAPI, allServices, serviceChange, setServiceChange, servicePending, isReferral, isAdmin } = useTabContext();

  const {
    register,
    control,
    watch,
    setValue,
    getValues,
    formState: { errors }
  } = useFormContext();

  const { permissions } = usePermissions();
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");

  console.log("provider info@!", providerInfo);

  useEffect(() => {
    if (providerInfo) {
      setLat(providerInfo.lat);
      setLng(providerInfo.lng);
    }
  }, [providerInfo]);

  const mapContainerStyle = {
    width: "100%",
    height: "400px"
  };

  const center = {
    lat: parseFloat(lat),
    lng: parseFloat(lng)
  };

  const formatPhoneNumber = value => {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;

    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
    }
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  };

  // Format phone and fax if they already have values on component mount
  useEffect(() => {
    const phoneValue = getValues("phone");
    const faxValue = getValues("fax");

    if (phoneValue) {
      const formattedPhone = formatPhoneNumber(phoneValue);
      if (phoneValue !== formattedPhone) {
        setValue("phone", formattedPhone, { shouldValidate: true, shouldDirty: true });
      }
    }

    if (faxValue) {
      const formattedFax = formatPhoneNumber(faxValue);
      if (faxValue !== formattedFax) {
        setValue("fax", formattedFax, { shouldValidate: true, shouldDirty: true });
      }
    }
  }, [getValues, setValue]);

  // Apply formatting when phone or fax changes
  useEffect(() => {
    const subscription = watch((value, { name }) => {
      if (name === "phone" || name === "fax") {
        const formattedValue = formatPhoneNumber(value[name]);
        if (value[name] !== formattedValue) {
          setValue(name, formattedValue, { shouldValidate: true, shouldDirty: true });
        }
      }
    });

    return () => subscription.unsubscribe();
  }, [watch, setValue]);

  return (
    <div className={isReferral ? "v3-db-tab-2-referral" : "v3-db-tab-2"}>
      <div className="provider-section v3-grid-item-a col-span-3">
        <h3>Organization Information</h3>
        <div className="my-2 text-sm">
          If you would like to make changes to your organization name or specific address fields, please <a href="/contact-us/">contact us here</a>
        </div>

        <div className="mt-4 grid grid-cols-4 items-center gap-4 pt-4">
          <div className="font-semibold">Organization Name:</div>
          <div className="col-span-3">
            <input type="text" name="org_name" id="org_name" className={`w-full ${!permissions.isAdmin && "input-readonly"}`} {...register("org_name")} />
          </div>

          <div className="font-semibold">Street Address:</div>
          <div className="col-span-3">
            <input type="text" name="google_address" id="google_address" className={`w-full ${!permissions.isAdmin && "input-readonly"}`} {...register("google_address")} />
          </div>

          <div className="font-semibold">City:</div>
          <div className="">
            <input type="text" name="city" id="city" className={`w-full ${!permissions.isAdmin && "input-readonly"}`} {...register("city")} />
          </div>

          <div className="font-semibold">County:</div>
          <div className="">
            <input type="text" name="county" id="county" className={`w-full ${!permissions.isAdmin && "input-readonly"}`} {...register("county")} />
          </div>

          <div className="font-semibold">State:</div>
          <div className="">
            <input type="text" name="state" id="state" className={`w-full ${!permissions.isAdmin && "input-readonly"}`} {...register("state")} />
          </div>

          <div className="font-semibold">Zip Code:</div>
          <div className="">
            <input type="text" name="zip" id="zip" className={`w-full ${!permissions.isAdmin && "input-readonly"}`} {...register("zip")} />
          </div>

          <div className="font-semibold">Phone:</div>
          <div className="">
            <input
              type="text"
              name="phone"
              id="phone"
              className="w-full"
              {...register("phone", {
                required: "Phone is required",
                pattern: {
                  value: /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/,
                  message: "Please enter a valid phone number XXX-XXX-XXXX"
                }
              })}
            />
            {errors.phone && <p className="error-text text-xs my-2">{errors.phone.message}</p>}
          </div>

          <div className="font-semibold">Fax:</div>
          <div className="">
            <input type="text" name="fax" id="fax" className="w-full" {...register("fax")} />
          </div>
        </div>
      </div>

      {!isReferral && (
        <div className="provider-section v3-grid-item-b row-span-3">
          {/* Heading */}
          <h3>Services {providerInfo?.name || "this provider"} Is Part Of</h3>
          <ul className="mt-2 ml-4 list-disc">
            {/* 1) Show the services the provider already has */}
            {allowedServices && allowedServices.length > 0 ? allowedServices.map(service => <li key={service.term_id}>{service.name}</li>) : <li>No services currently listed.</li>}
          </ul>

          {/* 2) Prompt for additional services */}
          <p className="mt-4">
            If you are licensed/certified for a level of care that does not show on your availability dashboard, please email your changes and copy of your license to our team at <a href="mailto:support@CareAvailability.com">support@CareAvailability.com</a> and we will make that change.
          </p>

          {/*    <ul className="mt-2 ml-4 list-disc">
            
            {allServices
              .filter(service => !allowedServices.find(allowed => allowed.term_id === service.term_id))
              .map(service => (
                <li key={service.term_id}>{service.name}</li>
              ))}
          </ul> */}

          {/* commenting this section out because pending changes is broken so this won't work anyway 
          {isAdmin && (
            <div className="provider-section v3-grid-item-b row-span-3">
              <h3>Allowed Services</h3>
              <h4 className="mt-2">If you would like to add a service to your listing, you must be licensed in your state to provide the service you select.</h4>
              <div className="mt-4 text-sm">(Note: If your facility contracts a third-party care agency to provide additional services, we cannot add it to your listing as your facility is not the licensed provider. If you are a third-party care agency to a facility like this, we cannot add their services to your listing since facilities have their own listings.)</div>
              <div className="mt-2 relative">
                <div className={`${servicePending ? "pointer-events-none" : ""}`}>
                  {allServices.map(service => (
                    <ServiceCheckbox key={service.term_id} service={service} setServiceChange={setServiceChange} disabled={servicePending} />
                  ))}
                </div>
                {servicePending && <div className="absolute inset-0 bg-gray-50 bg-opacity-50 flex items-center justify-center" />}
              </div>
              {servicePending && <div className="border border-yellow-500 bg-yellow-100 rounded-sm p-2 text-sm">There are currently services pending approval. Please wait for the approval process to complete before making any changes.</div>}
              {serviceChange && (
                <div className="border border-red-500 bg-red-100 rounded-sm p-2 text-sm">
                  <b>Note:</b> You are attempting to change a service. Please note that this change will be reviewed by our team before it is published.
                </div>
              )}
            </div>
          )}*/}
        </div>
      )}

      <div className="provider-section v3-grid-item-c col-span-3">
        <h3>Contact Information</h3>
        <h4 className="mt-2">
          Please include the email address for visitors to contact you via email/ or contact form. We will <b>never</b> publish your e-mail address for public display
        </h4>
        <div className="mt-4 md:grid grid-cols-4 items-center gap-4 pt-4">
          <div className="font-semibold">Email</div>
          <div>
            <input
              type="text"
              name="inquiry_email"
              id="inquiry_email"
              className={`w-full ${errors.inquiry_email ? "input-error" : ""}`}
              {...register("inquiry_email", { required: "Email is required" })}
              onChange={e => {
                setInquiryEmail(e.target.value);
              }}
            />
            {errors.inquiry_email && <p className="error-text">{errors.inquiry_email.message}</p>}
          </div>
        </div>
      </div>

      <div className="provider-section v3-grid-item-d col-span-3">
        <h3>Location</h3>
        <div className="py-2">
          {lat && lng && (
            <GoogleMap mapContainerStyle={mapContainerStyle} center={center} zoom={14}>
              <Marker position={center} />
            </GoogleMap>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListingDetails;
